// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Description
 */
export interface Description {
  /**
   *
   */
  description: string;
}

/**
 * Check if a given object implements the Description interface.
 */
export function instanceOfDescription(value: object): value is Description {
  if (!("description" in value) || value["description"] === undefined) return false;
  return true;
}

export function DescriptionFromJSON(json: any): Description {
  return DescriptionFromJSONTyped(json, false);
}

export function DescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Description {
  if (json == null) {
    return json;
  }
  return {
    description: json["description"],
  };
}

export function DescriptionToJSON(json: any): Description {
  return DescriptionToJSONTyped(json, false);
}

export function DescriptionToJSONTyped(
  value?: Description | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    description: value["description"],
  };
}
